import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = 'nominas/periodos-de-seguro-issste-detalles/';

/**
 * GET Periodos de Pago del ISSSTE (detalle)
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getPeriodosPagoISSSTEDetalle = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Periodo de Pago del ISSSTE (detalle) por ID
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getPeriodoPagoISSSTEDetalle = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Periodo de Pago del ISSSTE (detalle)
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPeriodoPagoISSSTEDetalle = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Periodo de Pago del ISSSTE (detalle)
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPeriodoPagoISSSTEDetalle = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}/`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Periodo de Pago del ISSSTE (detalle)
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deletePeriodoPagoISSSTEDetalle = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Periodo de Pago del ISSSTE (detalle)
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarPeriodoPagoISSSTEDetalle = async (id) => {
  try {
    const response = await API.patch(`${baseURI}${id}/`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
